import { defineStore } from 'pinia'
import { ref } from 'vue'

interface PrevPage {
  route_title: string
  route_host: string
  route_url: string
}

export const useHistoryStore = defineStore('history', () => {
  const prevPage = ref<PrevPage | null>(null)

  function setPrevPage(title: string, host: string, url: string) {
    prevPage.value = { route_title: title, route_host: host, route_url: url }
  }

  return { prevPage, setPrevPage }
})
